import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};
export const API_CREATE_ABOUT_US = async (data) => {
  try {
    const authToken = getAuthToken(); 
    const response = await PrivateAxiosInstance.post(
      "/about-us/create-about-us",
      data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
export const API_LIST_ABOUT_US = async (params) => {
  try {
    const authToken = getAuthToken(); 

    const response = await PrivateAxiosInstance.get(
      "/about-us/all-about-us",
      {
        headers: {
          Authorization: `${authToken}`, 
        },
        params: params, 
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
export const API_DELETE_ABOUT_US = async (id) => {
  try {
    const authToken = getAuthToken(); 

    const response = await PrivateAxiosInstance.delete(
      `/about-us/about-us/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
export const API_UPDATE_ABOUT_US = async (id, data) => {
  try {
    const authToken = getAuthToken(); 

    const response = await PrivateAxiosInstance.put(
      `/about-us/update-about-us/${id}`,
      data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
export const API_ENABLE_DISABLE_ABOUT_US = async (id) => {
  try {
    const authToken = getAuthToken(); 
    const response = await PrivateAxiosInstance.put(
      `/about-us/enable-disable-about-us/${id}`,
      null, 
      {
        headers: {
          Authorization: `${authToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};